export default "/fcbcac1db17390110677298f9d30eeed9c121039/dfffdcc654f425d556d7485c2bf841db.svg";